import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'AIzaSyCot-uXpn-w54wVvOL5t-ysUvFTQ8Au7tw',
  authDomain: 'potential-5635b.firebaseapp.com',
  databaseURL: 'https://potential-5635b.firebaseio.com',
  projectId: 'potential-5635b',
  storageBucket: 'potential-5635b.appspot.com',
  messagingSenderId: '530964328415',
  appId: '1:530964328415:web:69f41ec5aac68930645e6a',
  measurementId: 'G-YM3ZWFXVP3',
};

export default !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase;
export const db = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.database();
export const firestorage = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.storage();
export const firestore = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.firestore();
